import type { NameSearchResult as RawNameSearchResult } from '@rover/rsdk/src/apiClient/latest/model/nameSearchResult';

import type { NameSearchResult } from '../types';

export function mapToCardResult(raw: RawNameSearchResult): NameSearchResult {
  // personOpk is typed nullable but always set; fall back to personPk so testID/key stay stable.
  const personOpk = raw.personOpk ?? (raw.personPk != null ? String(raw.personPk) : '');

  return {
    personOpk,
    personName: raw.personFullName ?? '',
    shortName: raw.personShortName ?? '',
    avatarUrl: raw.defaultImage ?? null,
    profileUrl: raw.profileUrl ?? '',
    isPreviouslyBooked: raw.previouslyBooked ?? false,
    isStarSitter: raw.profileStatusBadgeData?.slug === 'star-sitter',
    ratingsAverage: raw.ratingsAverage ?? undefined,
    reviewsCount: raw.reviewsCount ?? undefined,
    neighborhood: raw.neighborhood ?? undefined,
    city: raw.city ?? undefined,
    state: raw.state ?? undefined,
    zip: raw.zip ?? undefined,
    repeatClientCount: raw.repeatClientCount ?? undefined,
    yearsOfExperience: raw.yearsOfExperience ?? undefined,
    primaryBadgeData: raw.primaryBadgeData ?? null,
    secondaryBadgeData: raw.secondaryBadgeData ?? [],
    profileStatusBadgeData: raw.profileStatusBadgeData ?? null,
    distanceDisplay: raw.distanceFromSearchCenterObj?.distanceDisplay ?? undefined,
    calendarRecency: raw.calendarRecency ?? null,
  };
}
